// pages/NotFound.tsx — 404 page.
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Wordmark } from '../components/Wordmark';

export function NotFound() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center py-24 text-center animate-fade-in">
      <Seo title="Not found — UPLOAD" description="Page not found." path="/404" />
      <Wordmark className="text-2xl" />
      <p className="mt-8 text-6xl font-bold tracking-tight text-brand">404</p>
      <h1 className="mt-2 text-xl font-semibold">This page doesn't exist</h1>
      <p className="mt-2 text-sm text-fg-muted">
        The link may be broken or the page may have moved.
      </p>
      <Link to="/" className="btn mt-8">
        Go home
      </Link>
    </div>
  );
}
